// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3d_if","unreadBadge":"styles_unreadBadge__1qyfl","modalContent":"styles_modalContent__3JXlP","modal":"styles_modal__1GJAM"};